// extracted by mini-css-extract-plugin
export default {"wrapper":"uXQqrZ","roundedFrame":"NiAejZ","thumbImage":"zL6QA9"};